export default __webpack_public_path__ + "static/media/GothamLight.03e7ff60.ttf";